import React, {useState, useRef, useEffect} from 'react';
import YouTube from 'react-youtube';
import PlayIcon from 'src/components/common/Icons/PlayIcon';
import s from './Video.module.scss';

const Video = (props) => {
  const {youtubeID, internalVideo, videoThumbnail, removeMarginBottom = 'false'} = props;
  const [yt, setYT] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isSeeking, setIsSeeking] = useState(false);
  const internalVideoRef = useRef(null);
  const pauseTimeoutRef = useRef(null);

  const handlePlayButton = () => {
    setIsPlaying(false);
    (!!internalVideoRef && !!internalVideoRef.current) && internalVideoRef.current.play();
    !!yt && yt.playVideo();
  }

  return (
    <div className={`${s.root} ${!!removeMarginBottom && removeMarginBottom == 'true' ? s.noMarginBottom : ""}`}>
      {!!youtubeID && 
        <YouTube 
          className={s.youtubeVideo}
          videoId={youtubeID} 
          onReady={(event) => setYT(event.target)}
        />
      }
      {(!youtubeID && !!internalVideo) && 
        <video 
          ref={internalVideoRef}
          className={s.video}
          width="900" 
          height="533" 
          controls={!!isPlaying} 
          poster={videoThumbnail?.url}
          onPlay={() => setIsPlaying(true)}
          onPause={() => {
            // Clear any existing timeout
            if (pauseTimeoutRef.current) {
              clearTimeout(pauseTimeoutRef.current);
            }
            // Set a timeout to check if seeking follows
            pauseTimeoutRef.current = setTimeout(() => {
              if (!isSeeking) {
                setIsPlaying(false);
              }
            }, 100);
          }}
          onSeeking={() => {
            setIsSeeking(true);
            // Clear the pause timeout if it exists
            if (pauseTimeoutRef.current) {
              clearTimeout(pauseTimeoutRef.current);
            }
          }}
          onSeeked={() => setIsSeeking(false)}
        >
          <source src={internalVideo?.url} type="video/mp4" />
        </video>
      }
      {(!isPlaying && !!videoThumbnail) && <img src={videoThumbnail.url} className={s.videoThumbnail}/>}
      {!isPlaying && <PlayIcon className={s.playIcon} onClick={handlePlayButton}/>}
    </div>
  );
};

export default Video;